import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({ className, dimension = 24 }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={dimension}
    height={dimension}
    viewBox="0 0 32 39"
    fill="none"
  >
    <path
      d="M7.96935 30.682H23.908V26.8467H7.96935V30.682ZM7.96935 23.0115H23.908V19.1762H7.96935V23.0115ZM3.98467 38.3525C2.88889 38.3525 1.95083 37.977 1.1705 37.2259C0.390166 36.4748 0 35.5719 0 34.5172V3.83525C0 2.78056 0.390166 1.87767 1.1705 1.1266C1.95083 0.375535 2.88889 0 3.98467 0H19.9234L31.8774 11.5057V34.5172C31.8774 35.5719 31.4872 36.4748 30.7069 37.2259C29.9266 37.977 28.9885 38.3525 27.8927 38.3525H3.98467ZM17.931 13.4234V3.83525H3.98467V34.5172H27.8927V13.4234H17.931Z"
      fill="#333333"
    />
  </svg>
);

export default Icon;
